import { registerFeatureWithDescription } from "lib/features"
import { FEATURE_FLAG_SCHEDULE_COMMENTARY } from "authoring/lib/enum/authoring-feature-flags.mjs"

registerFeatureWithDescription({
    numericalId: 407,
    id: FEATURE_FLAG_SCHEDULE_COMMENTARY,
    name: "Schedule Commentary",
    internalUseOnly: true,
    descriptionLines: ["Generates expert commentary documents for schedule updates."],
})
